import { defineStore } from 'pinia';
import { useSessionStore } from './session';

export const usePromotionStore = defineStore('promotion', () => {
    const sessionStore = useSessionStore();

    const promotions = computed(() => sessionStore?.order?.promotions);

    return {
        promotions,
    };
});
